import ShDialog from './src/main.vue'

ShDialog.install = Vue => {
  Vue.component(ShDialog.name, ShDialog)
}

export default ShDialog
